module.exports = __webpack_public_path__ + "media/kep-2.5d1b9aaf.mp4";